import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  advisorViewLayoutFooter: {
  }
}))

const Footer = ({ children, className, style }) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.advisorViewLayoutFooter, className)} style={style}>
      {children}
    </div>
  )
}

Footer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Footer
